<script>
  import { fade } from 'svelte/transition'
  import { fly } from 'svelte/transition'
  import SelectHeader from './SelectHeader.svelte'

  let wordlist = []
  let isCopied = false
  let currentWord = ''

  function handleMenuEvent(event) {
    console.log('settingschange', event.detail)
    if (event.detail?.reload) {
      fetchWords(event.detail)
    }
  }

  async function fetchWords(settings = { language: 'en', count: '10' }) {
    console.log('Fetching with settings', settings)
    const res = await fetch(`https://api.octillion.se/wordgen/${settings.language}/${settings.count}`)
    //const res = await fetch(`../words-tmp.json`)
    wordlist = await res.json()
  }

  function copyToClip(word) {
    navigator.clipboard.writeText(word).then(function () {
      console.log(`Copying ${word} to clipboard`)
      currentWord = word
      isCopied = true
      setTimeout(() => {
        isCopied = false
      }, 2000)
    })
  }
</script>

<SelectHeader on:menuChanges={handleMenuEvent} />
<div class="wordgen-main-content">
  {#if isCopied}
    <div class="clipboarded" transition:fade={{ delay: 0, duration: 500 }}>
      Copied: "<i>{currentWord}</i>"
    </div>
  {/if}
  <div class="wordgen-container">
    {#each wordlist as idword}
      <div on:click={() => copyToClip(idword.word)} transition:fly={{ y: 5, duration: 1000 }} class="wordcard">
        <span class="the-word">{idword.word}</span>
        <span class="subindex">{idword.index}</span>
      </div>
    {:else}
      <!-- this block renders when users.length === 0 -->
      <p>loading...</p>
    {/each}
  </div>
</div>

<style>
  .wordgen-main-content {
    padding: 1em;
    margin: auto;
    color: lightgrey;
    border-radius: 5px;
    font-size: 1.5em;
    margin-left: 5%;
    margin-right: 5%;
    background-color: rgba(6, 79, 148, 0.5);
    
  }

  .wordgen-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .wordcard {
    flex-grow: 5; 
    flex-shrink: 5;
    display: block;
    background: rgb(183, 183, 189);
    color: rgb(22, 22, 22);
    width: 200px;
    min-width: 180px;
    margin: 0.4rem;
    border-radius: 5px 5px 5px 5px;
    padding: 0.5rem;
    text-align: center;
    -webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.57);
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.57);
    position: relative;
  }

  .the-word {
    font-family: 'Arial';
    padding: 3px;
    font-size: 0.8em;
    margin: 0px;
  }

  .subindex {
    padding: 0px;
    margin: 0px;
    color: rgba(211, 211, 211, 0.3);
    font-size: 0.6em;
    display: none;
  }

  .clipboarded {
    position: fixed;
    top: 100px;
    font-size: 0.6em;
    padding: 3px;
    border-radius: 5px;
    vertical-align: center;
    color: black;
    z-index: 50;
    background-color: rgb(255, 255, 255);
  }
</style>
